export class Formatter {
    ellipsis(text, max) {
        if (text && text.length > max) {
            return text.substring(0, max) + '...';
        }
        return text;
    }
    formatDate(input) {
        let date = new Date(input);
        return new Intl.DateTimeFormat('en-GB', {
            timeStyle: 'short',
            dateStyle: 'full'
        }).format(date);
    }
    formatDateShort(input) {
        let date = new Date(input);
        return new Intl.DateTimeFormat('en-GB', {
            dateStyle: 'full'
        }).format(date);
    }
    formatDateUTC(input) {
        let date = new Date(input);
        return new Intl.DateTimeFormat('en-GB', {
            timeStyle: 'short',
            dateStyle: 'full',
            timeZone: 'UTC'
        }).format(date);
    }
    formatDateShortUTC(input) {
        let date = new Date(input);
        return new Intl.DateTimeFormat('en-GB', {
            dateStyle: 'full',
            timeZone: 'UTC'
        }).format(date);
    }
    getTimeZoneOffset() {
        return new Date().getTimezoneOffset() / 60;
    }
    getTimeZone() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    formatCurrency(currency_code, value, locale = 'en-GB') {
        let currencyFormat = (currency) => new Intl.NumberFormat(locale, { style: 'currency', currency });
        return currencyFormat(currency_code).format(value);
    }
    currencySymbol(currency_code) {
        let data = this.formatCurrency(currency_code, 0);
        return data.replace('0.00', '');
    }
    capitalize(str, lower = false) {
        return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }
    statusBox(status) {
        return {
            'status-box status-pending': status === 'Upcoming',
            'status-box status-expired': status === 'Expired',
            'status-box status-active with-ping': status === 'Active',
            'status-box status-cancelled': status === 'Inactive',
        };
    }
}
